export default __webpack_public_path__ + "static/media/9_I wish you enough.c02ee37f.jpg";